import { render, staticRenderFns } from "./relativedGroup.vue?vue&type=template&id=41e729ab&scoped=true&"
import script from "./relativedGroup.vue?vue&type=script&lang=js&"
export * from "./relativedGroup.vue?vue&type=script&lang=js&"
import style0 from "./relativedGroup.vue?vue&type=style&index=0&id=41e729ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e729ab",
  null
  
)

export default component.exports